import { render, staticRenderFns } from "./ChatEmptyState.vue?vue&type=template&id=3e13b35c&scoped=true"
import script from "./ChatEmptyState.vue?vue&type=script&lang=js"
export * from "./ChatEmptyState.vue?vue&type=script&lang=js"
import style0 from "./ChatEmptyState.vue?vue&type=style&index=0&id=3e13b35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13b35c",
  null
  
)

export default component.exports